import { render, staticRenderFns } from "./round-inline.mpx?vue&type=template&id=f951669c&isComponent&outputPath=components%2Fround-inline3241a07d%2Findex"
import script from "./round-inline.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fround-inline3241a07d%2Findex"
export * from "./round-inline.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fround-inline3241a07d%2Findex"
import style0 from "./round-inline.mpx?vue&type=style&index=0&id=f951669c&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_3241a07d%22%7D&isComponent&outputPath=components%2Fround-inline3241a07d%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports